export default "/kiban/_next/static/images/design-933f97bc50971607d9763b03e76ca321.png";